import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import Select from "../../../componentsReusable/Select";
import {useTranslation} from "react-i18next";

const RangesSelect = props => {
  const { t } = useTranslation('tec_rmi');
  const selectRef = useRef();
  const [rangeId, setRangeId] = useState(props.rangeId)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useDidMountEffect(() => {
    if(props.makeId){
      fetchData()
    }
  })

  useAfterUpdateEffect(() => {
    props.onChange(rangeId)
  }, [rangeId])

  useAfterUpdateEffect(() => {
    if(rangeId !== props.rangeId){
      setRangeId(props.rangeId)
    }
  }, [props.rangeId])

  useAfterUpdateEffect(() => {
    if(!props.rangeId && props.rangeName && data.length > 0){
      if(selectRef.current){
        selectRef.current.setState({ menuIsOpen: true, inputValue: props.rangeName })
        selectRef.current.focus()
      }
    }
  }, [data])

  useAfterUpdateEffect(() => {
    setData([])

    if(props.makeId){
      fetchData()
    }
  }, [props.makeId, props.showCar, props.showTruck, props.showBike])

  const fetchData = () => {
    setLoading(true)

    apiUser.tecRmi.vehicleTree.rangeList({
      showCar: props.showCar,
      showTruck: props.showTruck,
      showBike: props.showBike,
      makeId: props.makeId,
    }).then(res => {
      setData(res.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const getOptions = () => {
    return data
      .filter(range => {
        if(props.rangesIdFilter.length > 0 && !props.rangesIdFilter.includes(range.RangeId)){
          return false
        }

        return true
      })
      .map(parseDataToOption)
  }

  const parseDataToOption = (data) => ({
    value: data.RangeId,
    label: data.RangeName,
  })

  return <Select
    // autoFocus={!!props.makeId && !rangeId}
    ref={selectRef}
    placeholder={t('ranges_select.placeholder')}
    isLoading={loading}
    isDisabled={!props.makeId}
    options={getOptions()}
    onChange={setRangeId}
    value={rangeId}
  />};

RangesSelect.propTypes = {
  rangeId: PropTypes.number,
  rangesIdFilter: PropTypes.array,
  rangeName: PropTypes.string,
  makeId: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default RangesSelect;